<template>
  <div class="container pt-5">
    <vx-card title="Rutas de la aplicación">
      <slot name="content">
        <div class="inputs w-3/12">
          <div>
            <vs-input
              class="w-full"
              label="Ruta *"
              name="route_path"
              v-model.lazy="route.path"
              icon-pack="feather"
            ></vs-input>
          </div>
          <div>
            <vs-select
              placeholder="Seleccione"
              multiple
              label="Permisos"
              class="w-full"
              v-model="route.permissions"
            >
              <vs-select-item
                :key="index"
                :value="permission"
                :text="permission"
                v-for="(permission, index) in permissions" />
            </vs-select>
          </div>

          <vs-button
            @click="saveRoute()"
            color="primary" class="mt-5">
            Guardar ruta
          </vs-button>
        </div>
      </slot>
    </vx-card>
  </div>
</template>

<script>

import {RoleService} from "@/services/RoleService";

export default {
  name: "BackofficeRoutes",
  data: () => ({
    route: {
      path: "",
      permissions: ["admin"]
    },
    permissions: []
  }),
  async mounted() {
    if(this.$route.query.path) {
      this.route.path = this.$route.query.path;
    }

    let roles = await RoleService.all()
    this.permissions = roles.map((role) => role.guard_name)
  },
  methods: {
    async saveRoute() {
      await axios.post(`/api/backoffice/security/route`, this.route)
    }
  }
}
</script>

<style scoped>

</style>
